export default __webpack_public_path__ + "_/shared_modules/PlatformError/images/whoops-box-e865f57bbfcecb43f936d6669b9e6abc.svg";